@use "../../../../../styles/Constants.scss" as Constants;
@use "../../../../../styles/Colors.scss" as Colors;

.row {
	display: flex;
	align-items: center;
}

.instructions {
	font-size: Constants.$val-fontSizeBig;
	line-height: Constants.$val-lineHeightBig;
	margin-top: Constants.$val-spacing-xl;
}
